import { useState } from 'react';
import { submitRating } from './firebase';

const STORAGE_KEY = 'at_rated';

export default function RatingWidget() {
  const [stars,     setStars]     = useState(0);
  const [hover,     setHover]     = useState(0);
  const [comment,   setComment]   = useState('');
  const [submitted, setSubmitted] = useState(false);

  if (localStorage.getItem(STORAGE_KEY)) return null;

  const handleSubmit = async () => {
    if (!stars) return;
    await submitRating({ stars, comment });
    localStorage.setItem(STORAGE_KEY, '1');
    setSubmitted(true);
  };

  if (submitted) return (
    <div className="rating-wrap">
      <p className="rating-thanks">Thanks for your feedback! 🙏</p>
    </div>
  );

  return (
    <div className="rating-wrap">
      <p className="rating-title">How was your experience?</p>
      <div className="rating-stars">
        {[1,2,3,4,5].map(n => (
          <span
            key={n}
            className={`rating-star ${n <= (hover || stars) ? 'active' : ''}`}
            onClick={() => setStars(n)}
            onMouseEnter={() => setHover(n)}
            onMouseLeave={() => setHover(0)}
          >★</span>
        ))}
      </div>
      {stars > 0 && (
        <>
          <textarea
            className="rating-comment"
            placeholder="Leave a comment (optional, max 150 chars)"
            maxLength={150}
            rows={2}
            value={comment}
            onChange={e => setComment(e.target.value)}
          />
          <p className="rating-char-count">{comment.length}/150</p>
          <button className="rating-btn" onClick={handleSubmit}>Submit</button>
        </>
      )}
    </div>
  );
}
